import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { requestUrl, datasetUrl } from '@/constants/urls';
import SelectableCard from '@/components/cards/SelectableCard';
import CardItemDescription from '@/components/cards/CardItemDescription';
import CardItem from '@/components/cards/CardItem';
import RequestsCardHeader from '../components/RequestsCardHeader';
import { approvalStatus } from '../constants';
import RequestCardExtra from '../components/RequestCardExtra';
import { accessControlForTransfer, requestAccessContext } from '../helper';
import RequestTools from './RequestTools';
import ReviewRequestTools from './ReviewRequestTools';

const RequestsCardItem = ({
  allowTransfer,
  category,
  onCheckBoxClick,
  request,
  review,
  single,
  upward,
}) => (
  <CardItem
    className="aridhia-request-list-item"
    error={request.status === approvalStatus.ERROR}
    warning={!request.requester.active}
  >
    <Card.Content>
      <SelectableCard
        className="aridhia-card-header"
        onClick={onCheckBoxClick ? () => onCheckBoxClick(category, request.code) : undefined}
        selected={request.selected}
        single={single}
      >
        <RequestsCardHeader allowTransfer={allowTransfer} request={request} />
        {(!review) && (
          <RequestTools
            category={category}
            iconSize="large"
            listItem
            request={request}
            upward={upward}
            url={requestUrl(request, '#')}
          />
        )}
        {(review) && (
          <ReviewRequestTools
            category={category}
            iconSize="large"
            listItem
            request={request}
            upward={upward}
            url={requestUrl(request, '#')}
          />
        )}
      </SelectableCard>
      <Card.Meta>
        <FormattedMessage id={`transfer.type.${request.transfer.transfer_type}.verbose`} />
      </Card.Meta>
      {request.project_name && (<Card.Meta content={request.project_name} />)}
      {request.datasets[0]?.code && (
        <CardItemDescription href={datasetUrl(request.datasets[0])} value={request.datasets[0].catalogue.title} />
      )}
    </Card.Content>
    <RequestCardExtra request={request} allowTransfer={allowTransfer} />
  </CardItem>
);

const mapStateToProps = ({
  auth: { role: { permissions }, currentUser },
}, { request }) => {
  const context = requestAccessContext(request, currentUser);

  return ({
    allowTransfer: accessControlForTransfer(context, permissions).allowTransfer,
  });
};

export default connect(mapStateToProps)(RequestsCardItem);
